import { Helmet } from "react-helmet";
import { UserGroupIcon } from "@heroicons/react/24/outline";

import { TableCustomersList } from "../../tables/customers.list";
import { SectionHeader } from "../../components/layouts/section.header";
import { SectionSubHeader } from "../../components/layouts/section.subheader";

export const ScreenCustomersList = () => {
  return (
    <>
      <Helmet>
        <title>List Customer</title>
      </Helmet>

      <div className="min-h-screen w-full">
        <SectionHeader title="List Customer" />

        <div className="mt-10">
          <SectionSubHeader
            Icon={UserGroupIcon}
            title="Search Customers"
          />

          <TableCustomersList />
        </div>
      </div>
    </>
  );
};
